<div class="container">
  <div class="row card">
    <div class="card-body col-md-6">
      <h2 class="title">Tools</h2>
      <button
        class="btn btn-primary my-2 text-white text-uppercase"
        (click)="openLg(transcript)">
        View video transcript
      </button>
    </div>
  </div>
</div>

<ng-template #transcript let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Video Transcript - Recording Audio</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body fs-6" style="height: 35vh">
    <p>
      You're on your last step before publishing your story. You're doing an
      awesome job! In this video, I'm going to help you upload your audio to
      your story. Before we upload the audio, we want to do a little bit of
      editing on your story. Remember where we said, “Don't worry about commas.
      Don't worry about grammar.” Well, now we do want to worry about that just
      a little bit, but when you read it out loud, you'll know exactly what
      sounds right and where you need to make your adjustments in your story.
    </p>
    <p>
      Most laptops have a built-in microphone. If you have a traditional
      desktop, you may need to purchase a microphone to connect to your
      computer. You can also use your smartphone’s audio recording feature. You
      can email the audio to yourself and then upload it to this page or log
      onto your TSOLife account through your smartphone and record audio there.
      When you've identified your microphone source, click the Start Recording
      button. Click Stop Recording when you are finished. Click the Play button,
      the small triangle, to listen back to your recording. If satisfied, click
      Save to Story. If you would like to re-record, click Start Recording.
    </p>
    <p>Now let your story telling voice come through!</p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.close('Close click')">
      Close
    </button>
  </div>
</ng-template>
